(function () {

    'use strict';

    angular.module('app').controller('RoutesController', RoutesController);

    RoutesController.$inject = ['$q', 'RoutesTableService', '$routeParams', 'FleetService'];

    function RoutesController($q, RoutesTableService, $routeParams, FleetService) {
        const vm = this;
        const {areaId} = $routeParams;

        vm.getLink = getLink;
        if(areaId){
            FleetService.Areas.get(areaId, function (data) {
                vm.routesTableData = new RoutesTableService({['area.id']:data.id},data).tableData;
            }, function () {
                vm.routesTableData = new RoutesTableService().tableData;
            });
        }else{
            if($routeParams.code) {
                vm.routesTableData = new RoutesTableService({['code']:$routeParams.code.split(',')}).tableData;
            }else {
                vm.routesTableData = new RoutesTableService().tableData;
            }
        }

        function getLink() {
            if(areaId){
                return '/areas/details/' + areaId;
            }
            return null;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/routes/RoutesController.js